/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_AccountInputs */

const en_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Account`)
};

const fr_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer le compte`)
};

const de_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto verwalten`)
};

const it_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci account`)
};

const ru_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление учетной записью`)
};

const es_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar cuenta`)
};

const zh_cn2_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理账户`)
};

const ja_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント管理`)
};

const hi_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाते का प्रबंधन करें`)
};

const pt_pt2_manage_account = /** @type {(inputs: Manage_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar conta`)
};

/**
* | output |
* | --- |
* | "Manage Account" |
*
* @param {Manage_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manage_account = /** @type {((inputs?: Manage_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manage_account(inputs)
	if (locale === "de") return de_manage_account(inputs)
	if (locale === "it") return it_manage_account(inputs)
	if (locale === "ru") return ru_manage_account(inputs)
	if (locale === "es") return es_manage_account(inputs)
	if (locale === "zh-CN") return zh_cn2_manage_account(inputs)
	if (locale === "ja") return ja_manage_account(inputs)
	if (locale === "hi") return hi_manage_account(inputs)
	if (locale === "pt-PT") return pt_pt2_manage_account(inputs)
	return en_manage_account(inputs)
});